import AuthReducer from "./auth";
import ChannelReducer from "./channels";
import NotificationReducer from "./notifications";
import DialogReducer from "./dialog";
import PollReducer from "./polls/slice";
import CompletionsReducer from "./completions/index";
import AiUsageReducer from "./aiUsage";
import ParticipationReducer from "./participation";
import { combineReducers } from "@reduxjs/toolkit";

const rootReducer = combineReducers({
    channels: ChannelReducer,
    auth: AuthReducer,
    notifications: NotificationReducer,
    dialog: DialogReducer,
    poll: PollReducer,
    completions: CompletionsReducer,
    aiUsage: AiUsageReducer,
    participation: ParticipationReducer,
});

export interface RootStateInterface {
    auth: ReturnType<typeof AuthReducer>;
    channels: ReturnType<typeof ChannelReducer>;
    notifications: ReturnType<typeof NotificationReducer>;
    dialog: ReturnType<typeof DialogReducer>;
    poll: ReturnType<typeof PollReducer>;
    completions: ReturnType<typeof CompletionsReducer>;
    aiUsage: ReturnType<typeof AiUsageReducer>;
    participation: ReturnType<typeof ParticipationReducer>;
}

export default rootReducer;
